export const FunnelPageType = {
  SALES_PAGE: 'SalesPage',
  CHECKOUT_PAGE: 'CheckoutPage',
  UPSELL_PAGE: 'UpsellPage',
  PRESELL_PAGE: 'PresellPage',
  REFUND_POLICY_PAGE: 'RefundPolicyPage',
  TERMS_AND_CONDITIONS_PAGE: 'TermsAndConditionsPage',
  PRIVACY_POLICY_PAGE: 'PrivacyPolicyPage',
  CONTACT_US_PAGE: 'ContactUsPage',
  POLICY_PAGE: 'PolicyPage',
  OUR_STORY_PAGE: 'OurStoryPage',
  AFTERPAY_RETURN_PAGE: 'AfterpayReturnPage',
  ORDER_SUMMARY_PAGE: 'OrderSummaryPage',
};

export type FunnelPage_Type = (typeof FunnelPageType)[keyof typeof FunnelPageType];
